import * as fs from "node:fs"
import { join } from "node:path"

import { SupernovaConfig } from "../types/config.js"

const configFileName = "supernova.config.json"

export class SupernovaConfigService {
  private static instance: SupernovaConfigService
  private configCache: SupernovaConfig | null = null
  private readonly configPath: string

  private constructor() {
    this.configPath = join(process.cwd(), configFileName)
  }

  public static getInstance(): SupernovaConfigService {
    if (!SupernovaConfigService.instance) {
      SupernovaConfigService.instance = new SupernovaConfigService()
    }

    return SupernovaConfigService.instance
  }

  public get(): SupernovaConfig | null {
    if (this.configCache) return this.configCache
    if (!fs.existsSync(this.configPath)) return null

    try {
      const configString = fs.readFileSync(this.configPath, "utf8")
      const configJson = JSON.parse(configString)
      const configParseResult = SupernovaConfig.safeParse(configJson)

      if (configParseResult.success) {
        this.configCache = configParseResult.data
      }

      return this.configCache
    } catch (error) {
      throw new Error(`Could not read ${configFileName} file: ${(error as { message: string }).message}`)
    }
  }

  public update(configUpdate: Partial<SupernovaConfig>): void {
    const fullConfig = {
      ...this.get(),
      ...configUpdate,
    }

    this.write(fullConfig)
  }

  private write(config: SupernovaConfig): void {
    try {
      fs.writeFileSync(this.configPath, `${JSON.stringify(config, null, 2)}\n`)
      this.configCache = config
    } catch (error) {
      throw new Error(`Error saving config: ${(error as { message: string }).message}`)
    }
  }
}
